import {
    FETCH_START,
    FETCH_FAIL,
    EXAM_CREATED,
    TIMER_STARTED,
    QUESTION_ANSWERED,
    QUESTION_VIEWED,
    EXAM_REGISTERED
} from './examConstants'

const INITIAL_STATE = {
    exam: null,
    loading: false,
    timerStartDate: null,
    result: null
}

export default (state = INITIAL_STATE, action) => {
    let answers = [];

    switch (action.type) {
        case FETCH_START:
            return { ...state, loading: true };

        case FETCH_FAIL:
            return { ...state, loading: false };

        case EXAM_CREATED:
            return { ...state, loading: false, exam: action.payload, timerStartDate: null };

        case EXAM_REGISTERED:
            return { ...state, loading: false, result: action.payload, timerStartDate: null };

        case TIMER_STARTED:
            return { ...state, timerStartDate: action.payload };

        case QUESTION_ANSWERED:
            answers = [...state.exam.questoes];
            // console.log(answers, action.payload)
            answers[action.payload.key].resposta = action.payload.answer;
            return {
                ...state,
                exam: {
                    ...state.exam,
                    questoes: answers
                }
            };

        case QUESTION_VIEWED:
            answers = [...state.exam.questoes];
            answers[action.payload].vista = true;
            return {
                ...state,
                exam: {
                    ...state.exam,
                    questoes: answers
                }
            };

        default:
            return state
    }
}
